import {Component, OnInit} from '@angular/core';
import {HttpErrorResponse, HttpHeaders, HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Router, ActivatedRoute} from '@angular/router';
import {User} from '../../_models/user';
import {ApiIntegration} from '../../_services/api.integration';
import {Globals} from '../../_models/globals';
import {AlertService} from '../../_services/alert.service';
import {AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
//import {LocalStorageService, SessionStorageService, LocalStorage, SessionStorage} from 'angular-web-storage';

@Component({
  selector: 'app-customer-carriers',
  templateUrl: './customer-carriers.component.html',
  styleUrls: ['./customer-carriers.component.scss'],
})
export class CustomerCarriersComponent implements OnInit {
tabClicked = "active";
carriersList : any;
editCarrier : any;
index : any;
status : any;
deleteApiPop: string = 'N';

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
  this.getCarriersList("ACTIVE");
}


  populateTabData(triggered) {
    this.tabClicked = triggered;
  }

  getCarriersList(status){
  this.g.loaderDisplay="display";
  this.api.getCarrierList(this.user.accountOwnerId, status, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.carriersList = data;
      if(this.carriersList.length === 0){
        this.router.navigate(['/admin/carriersList']);
      }
      this.carriersList.forEach((c: any) => {
        if (c.status === 'ACTIVE' && c.carrierCode == 'SD') {
          c.enableShiftDelivery = true;
        }
        if (c.status === 'ACTIVE' && c.carrierCode == 'FE') {
          c.enableFedex = true;
        }
        if (c.status === 'ACTIVE' && c.carrierCode == 'SF') {
          c.enableShadowFax = true;
        }
        if (c.status === 'ACTIVE' && c.carrierCode == 'BD') {
          c.enableBlueDart = true;
        }
        if (c.status === 'ACTIVE' && c.carrierCode == 'DN') {
          c.enableDunzo = true;
        }
      });
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });

  }


 modifyStatus(){
 this.g.loaderDisplay = "display";
  this.api.deleteCarrierInfo(this.user.accountOwnerId, this.index.carrierId , this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.carriersList = data;
      this.getCarriersList("IN_ACTIVE");
      this.alertService.success(data['message']);
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });

  }

  getCarriersManage(m: any = {}, type = '') {
    if (type == 'SD') {
      this.router.navigate(['/admin/shiftDeliveryManage', {type, id: m.carrierId}]);
    } else if (type == 'FE') {
      this.router.navigate(['/admin/fedexManage', {type, id: m.carrierId}]);
    }  else if (type == 'SF') {
      this.router.navigate(['/admin/shadowFaxManage', {type, id: m.carrierId}]);
    } else if (type == 'BD') {
      this.router.navigate(['/admin/blueDartManage', {type, id: m.carrierId}]);
    } else if (type == 'DN') {
      this.router.navigate(['/admin/dunzoManage', {type, id: m.carrierId}]);
    } else if (type == 'DZ') {
      this.router.navigate(['/admin/dotzotManage', {type, id: m.carrierId}]);
    } else if (type == 'GT') {
      this.router.navigate(['/admin/gatiManage', {type, id: m.carrierId}]);
    } else if (type == 'VS') {
      this.router.navigate(['/admin/vamashipManage', {type, id: m.carrierId}]);
    } else if (type == 'WF') {
      this.router.navigate(['/admin/wefastManage', {type, id: m.carrierId}]);
    } else if (type == 'PR') {
      this.router.navigate(['/admin/pickrrManage', {type, id: m.carrierId}]);
    } else if (type == 'SY') {
      this.router.navigate(['/admin/shipyaariManage', {type, id: m.carrierId}]);
    } else if (type == 'SG') {
      this.router.navigate(['/admin/shippigoManage', {type, id: m.carrierId}]);
    } else if (type == 'DE') {
      this.router.navigate(['/admin/delhiveryManage', {type, id: m.carrierId}]);
    }
    this.g.loaderDisplay = "display";
    this.api.getCarrierInfoById(this.user.accountOwnerId, m.carrierId,this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.editCarrier = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

/*   showConnectBtn(code) {
    let show = false;
    if (this.carriersList) {
      this.carriersList.forEach((s) => {
        if (s.carrierCode === code) {
          show = true
        }
      });
    }
    return show;
  } */

   tabChange(){}

  closePopup() {
    this.deleteApiPop = 'n';
  }

  ngOnInit() {}

  testConnection(c){
this.g.loaderDisplay="display";
   var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.http.post(environment.apiUrl + 'api/testCarrierConnection',{
          "accountOwnerId": c.accountOwnerId,
          "carrierId": Number(c.carrierId),
          "organizationId": c.organizationId
    },
     {headers: header1}).subscribe(data => {
       this.g.loaderDisplay = "";
       if (data['code'] == 200) {
          this.alertService.success('Success',data['message']);
           }else{
          this.alertService.error('Error',data['message']);
             }
      },
      (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
      });
  }


  updateStatus(carrier) {

     let api = "";
      if (carrier.status === "ACTIVE") {
        api = 'api/deActivateCarrier';
        carrier.status = "IN_ACTIVE";
      } else {
        api = 'api/activateCarrier';
        carrier.status = "ACTIVE";
      }
       this.g.loaderDisplay = "display";
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.post(environment.apiUrl + api, {
          "accountOwnerId": this.user.accountOwnerId,
          "organizationId": this.user.organizationId,
          "status": carrier.status,
          "carrierId": carrier.carrierId
        },
        {headers: header1}).subscribe(data => {
            if (data['code'] == "200") {
            this.alertService.success(data['message']);
                  if (this.tabClicked === "ACTIVE") {
                this.getCarriersList("ACTIVE");
                }
                else{
                this.getCarriersList("IN_ACTIVE");
                }
          } else {
            this.alertService.error(data['message']);
          }
          this.g.loaderDisplay = "";
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });

  }
/*
  modifyStatus() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
    this.http.get(environment.apiUrl + 'api/deleteCarrierInfo', {
        "carrierId": this.index.carrierId,
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": this.user.organizationId
      },
      {headers: header1}).subscribe(data => {
          this.g.loaderDisplay = "";
          if (data['code'] == "200") {
            this.alertService.success(data['message']);
          } else {
            this.alertService.error(data['message']);
          }
        },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
 */

 deleteCarrier(data){
    this.deleteApiPop = 'Y';
    this.index = data;
}

}
